// extracted by mini-css-extract-plugin
module.exports = {"stepperIcon":"styles_stepperIcon__v-6c_","activeStepperIcon":"styles_activeStepperIcon__1E6ih","completedStepperIcon":"styles_completedStepperIcon__1bl5l"};